import { render, staticRenderFns } from "./ParticleViz.vue?vue&type=template&id=5fe28168&scoped=true"
import script from "./ParticleViz.vue?vue&type=script&lang=js"
export * from "./ParticleViz.vue?vue&type=script&lang=js"
import style0 from "./ParticleViz.vue?vue&type=style&index=0&id=5fe28168&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe28168",
  null
  
)

export default component.exports